import { useInspectList } from "./hooks/useInspectList";
import styles from "./InspectList.module.scss";
export default function InspectList() {
  const { items, handleRouteInspect } = useInspectList();

  return (
    <div className={styles["inspect-map__container"]}>
      {items.map((item) => (
        <div
          key={item.eeRequestId}
          className={styles["item"]}
          onClick={() => handleRouteInspect(item)}
        >
          {item.name}
        </div>
      ))}
    </div>
  );
}
